import {Component, inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';

import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';

@Component({
    selector: 'tgrid-request-access-modal',
    imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatInputModule,
    MatDialogClose,
    ReactiveFormsModule,
    MatIconModule,
],
    templateUrl: './request-access-modal.component.html',
    styleUrl: './request-access-modal.component.scss',
})
export class RequestAccessModalComponent {

  public data: string = inject(MAT_DIALOG_DATA);

  // @ts-expect-error: FormControl strict null check
  public reasonControl: FormControl<string> = new FormControl<string>('', Validators.required);

  constructor() {

  }
}
